<div class="form-info-text" [innerHTML]="infoText" *ngIf="infoText != ''"></div>
